/**
 * The client half of "these requested components are not included, proceed?"
 * (owner 2026-10-16, ORD-2026-00011). The server refuses an order bouquet that
 * differs from the manager's components with a 409 whose body carries
 * `code: ORDER_RECIPE_CHANGE_CONFIRMATION_REQUIRED` and, under `details`, what
 * was left out and what was added. The builder asks, then resends with
 * `acceptRecipeChanges: true`. Pure so it is testable without rendering.
 */
export interface RecipeChange {
  missing: { itemId: string; name: string }[];
  extra: { itemId: string; name: string }[];
}

function itemList(raw: unknown): RecipeChange["missing"] | null {
  if (!Array.isArray(raw)) return null;
  const out: RecipeChange["missing"] = [];
  for (const entry of raw) {
    if (typeof entry !== "object" || entry === null) return null;
    const { itemId, name } = entry as { itemId?: unknown; name?: unknown };
    if (typeof itemId !== "string" || typeof name !== "string") return null;
    out.push({ itemId, name });
  }
  return out;
}

export function parseRecipeChange(err: unknown): RecipeChange | null {
  if (typeof err !== "object" || err === null) return null;
  const status = (err as { status?: unknown }).status;
  const body = (err as { body?: unknown }).body;
  if (status !== 409 || typeof body !== "object" || body === null) return null;
  const b = body as { code?: unknown; details?: unknown };
  if (b.code !== "ORDER_RECIPE_CHANGE_CONFIRMATION_REQUIRED") return null;
  if (typeof b.details !== "object" || b.details === null) return null;
  const d = b.details as { missing?: unknown; extra?: unknown };
  const missing = itemList(d.missing);
  const extra = itemList(d.extra);
  if (!missing || !extra || missing.length + extra.length === 0) return null;
  return { missing, extra };
}
